import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import React from 'react';
import { getFirestore, collection, collectionGroup, CollectionReference } from 'firebase/firestore';
import { useCollection } from 'react-firebase-hooks/firestore';
import { app } from '../../core/firebase';
import { IConfirmation, IScoutRequest } from './schemas';
import BookingsList from './widgets/BookingsList';
import RequestsList from './widgets/RequestsList';

export interface IBookingsPage {

}

export default function BookingsPage() {
  const [bookings] = useCollection<IConfirmation>(collection(getFirestore(app), 'scout9-booking-confirmation') as CollectionReference<IConfirmation>);
  const [requests] = useCollection<IScoutRequest>(collectionGroup(getFirestore(app), 'requests') as CollectionReference<IScoutRequest>);

  return (
    <Container maxWidth="xl" disableGutters>
        <Grid container style={{padding: 24}} spacing={2}>
          <Grid item xs={6}>
            <Paper
              sx={{
                padding: 6,
                height: '80vh',
                maxHeight: '80vh',
                width: '100%',
                overflow: 'hidden'
              }}
            >
              <Grid container direction="column">
                <Typography variant="h6" style={{ marginBottom: 8 }}>Pending Requests</Typography>
                <Typography variant="caption" style={{ marginBottom: 16 }}>Requests waiting for bookings</Typography>
              </Grid>
              {requests && bookings && <RequestsList requests={requests} bookings={bookings}/>}
            </Paper>
          </Grid>

          <Grid item xs={6}>
            <Paper
              sx={{
                padding: 6,
                height: '80vh',
                maxHeight: '80vh',
                width: '100%',
                overflow: 'hidden'
              }}
            >
              <Grid container direction="column">
                <Typography variant="h6" style={{ marginBottom: 8 }}>Bookings</Typography>
                <Typography variant="caption" style={{ marginBottom: 16 }}>Total bookings</Typography>
              </Grid>
              {bookings && <BookingsList bookings={bookings}/>}
            </Paper>
          </Grid>
        </Grid>
    </Container>
  );
}
